// App.js
import React, { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import AdditionalParticipantsList from "./pages/AdditionalParticipantsList";
import AdditionalParticipantUpdate from "./pages/AdditionalParticipantUpdate";
import AdminPage from "./pages/admin/AdminPage";
import LoginPage from "./pages/admin/LoginPage";
import RegisterPage from "./pages/admin/RegisterPage";
import DirectoryBasicDetailsPage from "./pages/DirectoryBasicDetailsPage";
import DirectoryDetailsPage from "./pages/DirectoryDetailsPage";
import DirectoryPage from "./pages/DirectoryPage";
import EditRegistrationPage from "./pages/EditRegistrationPage";
import HomePage from "./pages/HomePage";
import PaymentCancel from "./pages/PaymentCancel";
import PaymentSuccess from "./pages/PaymentSuccess";
import RegistrationDetailsPage from "./pages/RegistrationDetailsPage ";
import RegistrationPage from "./pages/RegistrationPage";
import SaveOnlyRegistrationPage from "./pages/SaveOnlyRegistrationPage";

const AppContent = () => {
  const [sharedFormData, setSharedFormData] = useState({
    name: "",
    batch: "",
    mobile: "",
    email: "",
    profession: "",
    address: "",
  });

  const updateSharedFormData = (field, value) => {
    setSharedFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES - No authentication needed */}
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<RegisterPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route
          path="/directory"
          element={
            <DirectoryPage
              sharedFormData={sharedFormData}
              updateSharedFormData={updateSharedFormData}
            />
          }
        />
        <Route
          path="/edit-directory/:id"
          element={<DirectoryPage isEditMode={true} />}
        />

        <Route
          path="/register"
          element={
            <RegistrationPage
              sharedFormData={sharedFormData}
              updateSharedFormData={updateSharedFormData}
            />
          }
        />
        {/* <Route
          path="/edit-registration/:id"
          element={<RegistrationPage isEditMode={true} />}
        /> */}
        <Route
          path="/dir/register"
          element={<RegistrationPage isFromDirMode={true} />}
        />
        <Route
          path="/registration-details/:id"
          element={<RegistrationDetailsPage />}
        />
        <Route
          path="/directory-details/:id"
          element={<DirectoryDetailsPage />}
        />

        {/* <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/home" replace />
            </ProtectedRoute>
          }
        />

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payment-success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/payment-cancel"
          element={
            <ProtectedRoute>
              <PaymentCancel />
            </ProtectedRoute>
          }
        />

        <Route
          path="/directory"
          element={
            <ProtectedRoute>
              <DirectoryPage
                sharedFormData={sharedFormData}
                updateSharedFormData={updateSharedFormData}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/register"
          element={
            <ProtectedRoute>
              <RegistrationPage
                sharedFormData={sharedFormData}
                updateSharedFormData={updateSharedFormData}
              />
            </ProtectedRoute>
          }
        />
*/}
        <Route
          path="/edit-registration/:id"
          element={
            <ProtectedRoute>
              <EditRegistrationPage isEditMode={true} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-participant"
          element={
            <ProtectedRoute>
              <SaveOnlyRegistrationPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-payment-list"
          element={
            <ProtectedRoute>
              <AdditionalParticipantsList />
            </ProtectedRoute>
          }
        />

        {/* ADMIN ROUTE - Require admin authentication */}
        <Route
          // path="/auth/admin"
          path="/admin"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="directory-basic-details/:id"
          element={
            <ProtectedRoute requireAdmin={true}>
              <DirectoryBasicDetailsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="update-participant/:mobile"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdditionalParticipantUpdate />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/registration-details/:id"
          element={
            <ProtectedRoute>
              <RegistrationDetailsPage />
            </ProtectedRoute>
          }
        /> */}

        {/* Catch all - redirect appropriately */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;

// import React, { useState } from "react";
// import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import "./App.css";
// import ProtectedRoute from "./components/ProtectedRoute";
// import { AuthProvider } from "./context/AuthContext";
// import AdminPage from "./pages/admin/AdminPage";
// import LoginPage from "./pages/admin/LoginPage";
// import RegisterPage from "./pages/admin/RegisterPage";
// import DirectoryPage from "./pages/DirectoryPage";
// import HomePage from "./pages/HomePage";
// import PaymentCancel from "./pages/PaymentCancel";
// import PaymentSuccess from "./pages/PaymentSuccess";
// import RegistrationPage from "./pages/RegistrationPage";

// const AppContent = () => {
//   const [sharedFormData, setSharedFormData] = useState({
//     name: "",
//     batch: "",
//     mobile: "",
//     email: "",
//     profession: "",
//     address: "",
//   });

//   const updateSharedFormData = (field, value) => {
//     setSharedFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* PUBLIC ROUTES - No authentication needed */}
//         <Route path="/" element={<RegisterPage />} />
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/signup" element={<RegisterPage />} />
//         {/* <Route path="/payment-success" element={<PaymentSuccess />} />
//         <Route path="/payment-cancel" element={<PaymentCancel />} /> */}

//         {/* PROTECTED ROUTES - Require authentication */}
//         <Route
//           path="/payment-success"
//           element={
//             <ProtectedRoute>
//               <PaymentSuccess />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/payment-cancel"
//           element={
//             <ProtectedRoute>
//               <PaymentCancel />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/home"
//           element={
//             <ProtectedRoute>
//               <HomePage />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/directory"
//           element={
//             <ProtectedRoute>
//               <DirectoryPage
//                 sharedFormData={sharedFormData}
//                 updateSharedFormData={updateSharedFormData}
//               />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/register"
//           element={
//             <ProtectedRoute>
//               <RegistrationPage
//                 sharedFormData={sharedFormData}
//                 updateSharedFormData={updateSharedFormData}
//               />
//             </ProtectedRoute>
//           }
//         />

//         <Route
//           path="/edit-registration/:id"
//           element={
//             <ProtectedRoute>
//               <RegistrationPage isEditMode={true} />
//             </ProtectedRoute>
//           }
//         />

//         {/* ADMIN ROUTE - Require admin authentication */}
//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute requireAdmin={true}>
//               <AdminPage />
//             </ProtectedRoute>
//           }
//         />

//         {/* Catch all - redirect to home if logged in, otherwise to login */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </BrowserRouter>
//   );
// };

// function App() {
//   return (
//     <AuthProvider>
//       <AppContent />
//     </AuthProvider>
//   );
// }

// export default App;
